module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field-select",
    class: {
      show: _vm.show
    }
  }, [_c('div', {
    staticClass: "field-select-block",
    attrs: {
      "layout": "row",
      "layout-align": "space-between stretch"
    }
  }, [_c('input', {
    ref: "selectInput",
    attrs: {
      "type": "text",
      "flex": "",
      "readonly": ""
    },
    domProps: {
      "value": _vm.activeItem.name
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "keyup": _vm.handleKeyup
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label-icon",
    attrs: {
      "layout": "row",
      "layout-align": "center center"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_c('k-icon', {
    attrs: {
      "xlink": "#icon-arrow-down"
    }
  })], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-up",
      "mode": "out-in"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "field-select-box",
    style: ({
      zIndex: _vm.$knife.getZIndex()
    })
  }, _vm._l((_vm.optionsSlots), function(item, index) {
    return _c('li', {
      key: item.value || index,
      staticClass: "field-option",
      class: {
        active: (_vm.activeItem && _vm.activeItem.value === item.value)
      },
      on: {
        "click": function($event) {
          _vm.choose(item)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n    ")])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40bdf05f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KSelect.vue
// module id = 118
// module chunks = 1